<template>
  <div>
        
  </div>
</template>
<script>
import { mapActions } from 'vuex';

const accountModule = 'accountModule'

export default {
  data() {
    return {

    }
  },

  methods: {
    ...mapActions(accountModule, [
      'requestCheckNaverAccount',
      'requestNaverLogin',
      'requestNaverSignup'
    ]),

    async setRedirectData() {
      const code = this.$route.query.code;
      const naverCheck = await this.requestCheckNaverAccount(code)

      if (naverCheck) {
        await this.requestNaverLogin(code)
        this.$router.push({ name: 'home' })
      } else {
        await this.requestNaverSignup(code)
        alert('환영합니다')
        this.$router.push({ name: 'home' })
      }
    }
  },

  mounted() {
    this.setRedirectData()
  }
}
</script>
<style lang="">
    
</style>